$(function ($) {
  function hide_currency_selector() {
    if ($(".locale-selectors__container").length > 0) $(".locale-selectors__container")[0].parentNode.style.display="none";
    else setTimeout(hide_currency_selector, 200);
  }
  hide_currency_selector();
  $('.product-single__description h4').each(function(){ 
    var $set = $(this).nextUntil("h4");
    $set.wrapAll('<div class="panel" />');
  });

  $(".product-single__description h4").addClass('accordion');
  $('.panel').hide();

  $(".rte.product-single__description > .accordion:nth-child(1)").addClass('open').next('.panel').show();  
  $('.product-single__description .accordion').on('click', function(){
    // $('.panel').hide();
    //$('.accordion').removeClass('active');
    $(this).toggleClass('open');
    var isVisible = $(this).next().is(':visible');
    console.log(isVisible);
    if(isVisible == true){
      $(this).next().hide(300);
    }else{
      $(this).next().show(300);
    }
  });
});



$(function(){
    $('#create_customer').submit(function(e) {     
      if ( $('input[name="customer[password]"]').val() != $('input[name="customer[password_confirmation]"]').val()) {
        e.preventDefault();
        alert('Passwords do not match.');
      }
    });
  });



/*start slick slider*/
jQuery(document).ready(function(){

$(".vr_header_wrapper").sticky();  

// $(window).scroll(function () {
//   if($(window).scrollTop() > 1) {
//     $(".vr_header_wrapper").addClass('sticky').animate({ top: '0px' });
//   } else {
//     $(".vr_header_wrapper").removeClass('sticky');
//   }
// });  

// var nav = $('.vr_header_wrapper');
// var scrolled = false;

// $(window).scroll(function () {

//     if (100 < $(window).scrollTop() && !scrolled) {
//         nav.addClass('sticky').animate({ top: '0px' });
//         scrolled = true;
//     }

//    if (100 > $(window).scrollTop() && scrolled) {
//         nav.removeClass('sticky').css('top', '-30px');
//         scrolled = false;      
//     }
// });

  
// var scroll = $(document).scrollTop();
// var headerHeight = $('.vr_header_wrapper').outerHeight();

// $(window).scroll(function() {
//     var scrolled = $(document).scrollTop();

//     if (scrolled > headerHeight){
//         $('.vr_header_wrapper').addClass('off-canvas');
//     } else {
//         $('.vr_header_wrapper').removeClass('off-canvas');
//     }

//     if (scrolled > scroll){
//         $('.vr_header_wrapper').removeClass('fixed');
//     } else {
//         $('.vr_header_wrapper').addClass('fixed');
//     }               
//     scroll = $(document).scrollTop();   
// });
  

jQuery("#mobile_search").on("click", function() {
  jQuery(".mobile_search_box").slideToggle();
});

  
jQuery(".pro_tabs .aditional_info").on("click", function() {
  $(".pro_description").removeClass("active");
  $(this).addClass("active");
  $(".descrip_data").hide();
  $(".additional_data").show();
});
  
jQuery(".pro_tabs .pro_description").on("click", function() {
  $(".aditional_info").removeClass("active");
  $(this).addClass("active");
  $(".additional_data").hide();
  $(".descrip_data").show();
});
  
$(".vr_header h2").on("click", function() {
  $(".vr_header h2").removeClass("active");
  $(this).addClass("active");
});

jQuery('.slick_menus').slicknav({
  allowParentLinks: false,
  prependTo: '#sk_slick_menu',
  label: 'Menu'
});

jQuery('.query_btn').on('click', function(){
    $("#product_url").val('https://www.vanrijkestatejewellers.com' + $(this).attr('data-product-url'));
    $("#product_sku").val($(this).attr('data-product-sku'));
    localStorage.setItem(jQuery('.query_btn').attr("data-product-url") + "-requested_again", false);
    let data = localStorage.getItem(jQuery('.query_btn').attr("data-product-url") + "-remember_me");
    if (data && data.name) document.querySelector("#ContactFormName").value = data.name;
    if (data && data.email) document.querySelector("#ContactFormEmail").value = data.email;
    if (data && data.phone) document.querySelector("#ContactFormPhone").value = data.phone;
    if (data && data.message) document.querySelector("#ContactFormMessage").value = data.message;
    jQuery('.contact-form.form-popup').addClass('active');
    jQuery('.template-product').addClass('active');
});

jQuery('.submit-inquiry').on('click', function () {
  if ($("#contact_form").length > 0 && $("#ContactFormMessage").val() && $("#ContactFormPhone").val() && $("#ContactFormEmail").val() && $("#ContactFormName").val()) {
    $.ajax({
      url: "https://chiquel-cron-canadaorder.bryka.com/api/vanrijk/enquiry",
      type: "POST",
      data: $("#contact_form").serialize()
    });
    let json = {
      n: $("#ContactFormName").val(),
      e: $("#ContactFormEmail").val(),
      p: $("#ContactFormPhone").val(),
      m: $("#ContactFormMessage").val(),
    };
    localStorage.setItem('enqury-from-data', JSON.stringify(json));
    localStorage.setItem(jQuery('.query_btn').attr("data-product-url") + '_data', JSON.stringify(json));
  }    
});

jQuery('.popup_close').on('click', function() {
    // if (jQuery(".form-success").length > 0) {
      // localStorage.setItem(jQuery('.query_btn').attr("data-product-url"), true);
      // document.querySelector(".query_btn.pro_btn").style.display="none";
      // document.querySelector(".query_text").style.display="inline-block";
    // }
    jQuery('.contact-form.form-popup').removeClass('active');
    jQuery('.template-product').removeClass('active');  
});

jQuery('.requested_close').on('click', function() {
  localStorage.setItem(jQuery('.query_btn').attr("data-product-url"), false);
  localStorage.setItem(jQuery('.query_btn').attr("data-product-url") + "-requested_again", true);
  document.querySelector(".query_btn.pro_btn").style.display="inline-block";
  document.querySelector(".query_text").style.display="none";
  document.location.href = jQuery('.query_btn').attr("data-product-url");
});

// jQuery('.slick_menus_tab').slicknav({
//   allowParentLinks: false,
//   prependTo: '#sk_slick_menu_tab',
//   label: ''
// });

// jQuery(".menu_sl_close_tab").on("click", function() {
//   jQuery('.slick_menus_tab').slicknav('close');  
// });
  
  
// jQuery(".menu_sl_close").on("click", function() {
//   jQuery('.slick_menus').slicknav('close');  
// });

//   jQuery(".sticky_icon, .close_sticky_form, .close_form, .open_stky_form").on("click", function() {
//     jQuery(".stickr_form").toggleClass("active");
//   });




  

});

/*end slick slider*/